import { withInstall } from "../utils/index.mjs";
import _FloatingBubble from "./FloatingBubble.mjs";
const FloatingBubble = withInstall(_FloatingBubble);
var stdin_default = FloatingBubble;
import { floatingBubbleProps } from "./FloatingBubble.mjs";
export {
  FloatingBubble,
  stdin_default as default,
  floatingBubbleProps
};
